import React from "react";

function ProgressBar({
  totalBars = 20,
  filledBars,
  filledColor = "#FFA500", // orange
  emptyColor = "#eee",
  barWidth = 8,
  barHeight = 32,
  barSpacing = 4,
}) {
  return (
    <div style={{ display: "flex", gap: `${barSpacing}px` }}>
      {Array.from({ length: totalBars }).map((_, i) => (
        <div
          key={i}
          style={{
            width: `${barWidth}px`,
            height: `${barHeight}px`,
            backgroundColor: i < filledBars ? filledColor : emptyColor,
            borderRadius: "2px",
          }}
        />
      ))}
    </div>
  );
}

export default ProgressBar;
